<div class="container-fluid py-2">

  <header class="sl__head">
    <div class="sl__title-block">
      <h2 class="sl__title">
        <span class="sl__title-icon">
          <i class="fa-solid fa-book-open-reader"></i>
        </span>
        {{ 'SUBJECTS.LIST_TITLE' | translate }}
      </h2>
      <p class="sl__sub">
        {{ total() }}
        {{ 'SUBJECTS.LIST_COUNT' | translate }}
      </p>
    </div>

    <div class="sl__search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="text"
             class="sl__search-input"
             [ngModel]="searchQuery"
             (ngModelChange)="searchQuery = $event"
             [placeholder]="'SUBJECTS.SEARCH_PLACEHOLDER' | translate"
             name="subject-search" />
    </div>
  </header>

  @if (errored()) {
    <!-- Erreur de chargement : jamais de matières de substitution -->
    <app-error-state titleKey="SUBJECTS.ERROR_TITLE"
                     messageKey="SUBJECTS.ERROR_DESC"
                     (retry)="reload()"></app-error-state>
  } @else if (loading()) {
    <div class="sl__grid">
      @for (_ of [1,2,3,4,5,6]; track $index) {
        <div class="sl__skeleton"></div>
      }
    </div>
  } @else if (rows().length === 0) {
    <app-empty-state icon="book"
                     titleKey="SUBJECTS.EMPTY_TITLE"
                     messageKey="SUBJECTS.EMPTY_DESC"></app-empty-state>
  } @else {

    <!-- ─── Mes matières favorites ─────────────────────────────────── -->
    @if (favorites().length) {
      <section class="sl__section">
        <h3 class="sl__section-title">
          <i class="fa-solid fa-star"></i>
          {{ 'SUBJECTS.FAVORITES_TITLE' | translate }}
          <span class="sl__section-count">{{ favorites().length }}</span>
        </h3>

        <div class="sl__grid">
          @for (subject of favorites(); track subject.subjectId) {
            <app-subject-action-card
              [subject]="subject"
              [showFavorite]="true"
              [isFavorite]="subject.isFavorite"
              (favoriteToggled)="toggleFavorite(subject, $event)"></app-subject-action-card>
          }
        </div>
      </section>
    }

    <!-- ─── Les autres ─────────────────────────────────────────────── -->
    @if (others().length) {
      <section class="sl__section">
        @if (favorites().length) {
          <h3 class="sl__section-title sl__section-title--muted">
            <i class="fa-solid fa-layer-group"></i>
            {{ 'SUBJECTS.OTHERS_TITLE' | translate }}
          </h3>
        }

        <div class="sl__grid">
          @for (subject of others(); track subject.subjectId) {
            <app-subject-action-card
              [subject]="subject"
              [showFavorite]="true"
              [isFavorite]="subject.isFavorite"
              (favoriteToggled)="toggleFavorite(subject, $event)"></app-subject-action-card>
          }
        </div>
      </section>
    }

    @if (total() === 0) {
      <div class="sl__empty">
        <i class="fa-solid fa-folder-open"></i>
        <p>{{ 'SUBJECTS.NO_RESULTS' | translate }}</p>
      </div>
    }
  }

</div>
